import styled from 'styled-components';
import { layout } from 'styles/layout'

// max-width: 100vw !important is needed to override the layout's 1440px
export const CreatorsBackground = styled.div`
  position: relative;
  display: grid;
  max-width: 100vw !important;
  background: rgba(28,171,191,.08);
  padding: 4em 0 0;

  @media screen and (min-width: ${layout.xs}) {
    padding: 4em 0;
  }
`

export const CreatorsContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  text-align: center;
  justify-self: center;
  z-index: 1;

  & > div {
    & > h1 {
    max-width: 1224px;
    justify-self: center;
    width: 90%;
    margin: 0 auto;
  }
}
`
